import React from 'react';
import hero from '../../assets/images/login-hero.jpg';
import logo from '../../assets/images/USDA_logo_xs.png';
import { I18n } from '@kineticdata/react';

export const LoginWrapper = ({ children, title = 'Sign In', subtitle }) => (
  <div className="login-container">
    <div className="login-wrapper">
      <div className="login-heading">
        <div>
          <span className="h4">
            <I18n>{title}</I18n>
          </span>
          {subtitle && <span className="d-block">{subtitle}</span>}
        </div>
        <img src={logo} alt="Logo" className="ml-auto" />
      </div>
      <div
        className="login-content"
        style={{ backgroundImage: `url(${hero})` }}
      >
        {children}
      </div>
    </div>
  </div>
);
